import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title,
    description,
    keywords,
    canonical,
    image,
    noindex = false
}) => {
    const siteTitle = "haeppy.app"; // Default site title, can be replaced with a dynamic value if needed
    const defaultDescription = "Automatisiere deine Marktplatz-Anbindungen mit haeppy.app – die SaaS-Plattform für effiziente Multi-Channel-Prozesse im E-Commerce."; // Default description

    return (
        <Helmet>
            <title>{title ? `${title} ~ ${siteTitle}` : siteTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            {keywords && <meta name="keywords" content={keywords} />}
            {canonical && <link rel="canonical" href={canonical} />}
            {noindex && <meta name="robots" content="noindex,nofollow" />}

            {/* Open Graph */}
            <meta property="og:title" content={title || siteTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            {image && <meta property="og:image" content={image} />}

            {/* Twitter */}
            <meta name="twitter:title" content={title || siteTitle} />
            <meta name="twitter:description" content={description || defaultDescription} />
            {image && <meta name="twitter:image" content={image} />}
        </Helmet>
    );
};

export default SEO;